import { forwardRef, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  function Textarea({ className, label, hint, id, rows = 4, ...props }, ref) {
    const tid = id ?? props.name;
    return (
      <div className="w-full">
        {label && (
          <label htmlFor={tid} className="label">
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          id={tid}
          rows={rows}
          className={cn(
            "w-full bg-bg-input border border-border rounded px-3 py-2 text-sm text-text-primary resize-y",
            "placeholder:text-text-tertiary focus:border-border-accent focus:ring-1 focus:ring-accent/30",
            className,
          )}
          {...props}
        />
        {hint && <p className="mt-1 text-xs text-text-tertiary">{hint}</p>}
      </div>
    );
  },
);
